import React from "react";
import { Container } from "react-bootstrap";
import RichText from "components/rich-text";
import getImagePath from "helpers/get-image-path";
// import Mail from "assets/images/mail.png";
// import Phone from "assets/images/phone.png";
// import locale from "locales";
import FloatingHero from "../floating-hero";

import {
  contactHero, chContent, chMedia, chText,
  chTitle,chMediaDesktop, chMediaMobile, contactHeroContainer,
  // chBoxes, firstBox, secondBox, contactUrl
} from "./style.mod.scss";

const ContactHero = ({ data }) => {

  const { title, hero, content } = data;
  const bgColor = data?.bgColor?.hex;

  return data?.floatingHero ? <FloatingHero data={data} /> : (
    <div className={contactHero} style={{ backgroundColor: bgColor ? bgColor : "inherit" }}>
      <Container className={contactHeroContainer}>
        <div className={chContent}>
          <div className={chText}>
            <h1 className={chTitle}>{title}</h1>
            <RichText blocks={content} />
          </div>
          {/* <div className={chBoxes}>
            <div className={firstBox}>
              <img src={Phone} alt="Phone" />
              <a className={contactUrl} href={`tel:${locale.pages.contact.phone}`}>{locale.pages.contact.phone}</a>
              <p>{locale.pages.contact.workingDays}</p>
            </div>
            <div className={secondBox}>
              <img src={Mail} alt="Mail" /?
              <a className={contactUrl} href={`mailto:${locale.pages.contact.email}`}>{locale.pages.contact.email}</a>
              <p>24/7</p>
            </div>
          </div> */}
        </div>
        <div className={`${chMedia} ${chMediaMobile}`}>
          <img src={getImagePath(hero, true)} alt={hero?.alt}/>
        </div>
      </Container>
      <div className={`${chMedia} ${chMediaDesktop}`}>
        <img src={getImagePath(hero, true)} alt={hero?.alt}/>
      </div>
    </div>
  );
};

export default ContactHero;
